import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ExerciseSteps from 'modules/student/worksheets/components/ExterciseSteps';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 800,
    minWidth: 650,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 8,
    paddingLeft: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
  },
  desc: {
    marginBottom: theme.spacing(3),
  },
  body: {
    padding: 16,
  },
}));

const Preview = ({ data, module }) => {
  const classes = useStyles();

  return (
    <Box className={classes.paper}>
      <div className={classes.body}>
        <Box marginBottom={2}>
          <Typography gutterBottom color="textSecondary" variant="caption">
            {module?.name} ~ {data.duration} minutes
          </Typography>
          <Typography
            gutterBottom
            className={classes.title}
            variant="subtitle1"
            color="textPrimary"
          >
            {data.name}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            className={classes.desc}
          >
            {data.description}
          </Typography>
        </Box>
        <ExerciseSteps blocks={data.blocks} />
      </div>
    </Box>
  );
};

export default Preview;
